import { useEffect, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import { Link } from 'react-router-dom';

import { passToWebView } from '../../../library/Funcs';

import './Banners.css';
import 'react-image-gallery/styles/css/image-gallery.css';

const Banners = (props) => {
    const [banners, setBanners] = useState([]);

    useEffect(() => {
        let bannerList = [];

        for (let i = 0; i < props.banners?.length; i++) {
            const banner = props.banners[i];
            const img = <img src={banner.image} />;
            let link;

            if (banner.model == 'SHOP') {
                link = <Link to="#" onClick={props.showShop}>{img}</Link>;
            } else if (banner.model == 'PRODUCT') {
                link = <Link to={{ pathname: `/shop/${banner.model_id}` }}>{img}</Link>;
            } else if (banner.model == 'PROJECT') {
                link = <Link to={{ pathname: `/campaign/${banner.model_id}` }}>{img}</Link>;
            } else if (banner.model == 'PROJECT_UPDATE') {
                link = <Link to={{ pathname: `/campaign/${banner.model_id}`, state: { showUpdates: true } }}>{img}</Link>;
            } else if (banner.model == 'BLOG') {
                link = <Link to={{ pathname: `/blog/${banner.model_id}` }}>{img}</Link>;
            } else if (banner.model == 'USSD_CODE') {
                link = <Link to="#" onClick={() => passToWebView("sendPayment", `tel:${banner.model_id}`)}>{img}</Link>;
            }

            bannerList.push({
                renderItem: () => {
                    return link
                }
            });
        }

        setBanners(bannerList);
    }, [props.banners])

    return <ImageGallery items={banners} autoPlay showThumbnails={false} showNav={false} showPlayButton={false} showFullscreenButton={false} slideInterval={5000} />
}

export default Banners